/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, April 18th 2022, 10:29:42 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { TextAreaFormInput, TextFormInputProps } from "ui-widgets/forms";
import { useOSFormContext } from "ui-widgets/forms/providers";
import { ContextTagSelectorButtonWrapper } from "common/components/context-tags";
import { useServiceBuilderContext } from "service-builder/providers";
import { OSActionButton } from "ui-widgets";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

type TextContentInputProps<T> = Pick<TextFormInputProps<T>, "schema_field_key" | "label" | "helperText">;

export const TextContentInput = <T,>(props: TextContentInputProps<T>) => {
  const { setValue, watch } = useOSFormContext<T>();

  const onSelectTag = React.useCallback(
    (tagContent: string) => {
      const currentValue = watch(props.schema_field_key as any);
      setValue(props.schema_field_key as any, `${currentValue} ${tagContent}` as any);
    },
    [props.schema_field_key, setValue, watch]
  );

  const {
    processDefinitionContext: { currentProcessDefinition },
  } = useServiceBuilderContext();

  return (
    <Stack rowGap={"10px"}>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h4" sx={{ fontWeight: 800, fontSize: "0.8rem" }}>
          {props.label}
        </Typography>
        <ContextTagSelectorButtonWrapper
          onCopyContextTag={({ tag, tagName }) => {
            onSelectTag(`${tagName}: ${tag}`);
          }}
          copiedMessage="Appended to Textbox!!"
          contextTagsAPIFilters={{ process_definition: currentProcessDefinition.id }}
        >
          {({ openContextTagsFn }) => (
            <OSActionButton onClick={openContextTagsFn} variant="contained">
              Use Context Tags
            </OSActionButton>
          )}
        </ContextTagSelectorButtonWrapper>
      </Stack>
      <TextAreaFormInput<T> schema_field_key={props.schema_field_key} label={null} />
    </Stack>
  );
};
